import { Icon } from "./Icon";

interface Props {
  message: string;
  on: boolean;
  /** Shows the prototype's check mark. Off for a failure, which must not look like a success. */
  done?: boolean;
}

/** The prototype's toast: a light note at the bottom of the screen. */
export function Toast({ message, on, done = true }: Props) {
  return (
    <div className={on ? "toast on" : "toast"} role="status" aria-live="polite">
      {done && <Icon name="check" />}
      <span>{message}</span>
    </div>
  );
}
